export default __webpack_public_path__ + "static/media/main-image.5331b68c.jpg";